module.exports = __webpack_public_path__ + "img/close.7de0a0d5.svg";